module.exports = new __parcel__URL__("select-smartsheet-csv.ba0932f3.svg").toString();